/* POPUP PROMOCIONAL v1 - BPM Theme */
;(function(){

/* =========================================================
   UTILIDADES
   ========================================================= */
var STORAGE_KEY_PREFIX = 'promo_popup_';

function storageGet(key){
  try{ return localStorage.getItem(STORAGE_KEY_PREFIX+key); }catch(e){ return null; }
}
function storageSet(key,val){
  try{ localStorage.setItem(STORAGE_KEY_PREFIX+key,val); }catch(e){}
}

function deveExibir(config){
  var freq = config.frequencia;
  if(freq === 'sempre') return true;

  var agora   = Date.now();
  var ultima  = parseInt(storageGet('ultima_exib')||'0', 10);
  var recusou = storageGet('recusou') === '1';

  if(recusou) return false;

  if(freq === 'sessao'){
    // Usa sessionStorage para "por sessão"
    try{
      if(sessionStorage.getItem(STORAGE_KEY_PREFIX+'sessao')) return false;
    }catch(e){}
    return true;
  }
  if(freq === 'dia'){
    return (agora - ultima) > 86400000; // 24h
  }
  if(freq === 'semana'){
    return (agora - ultima) > 604800000; // 7 dias
  }
  return true;
}

function marcarExibido(config){
  var agora = Date.now();
  storageSet('ultima_exib', ''+agora);
  if(config.frequencia === 'sessao'){
    try{ sessionStorage.setItem(STORAGE_KEY_PREFIX+'sessao','1'); }catch(e){}
  }
}

/* =========================================================
   VIDEO EMBED
   ========================================================= */
function buildVideoEmbed(url){
  if(!url||typeof url!=='string')return'';
  url=url.trim();

  // YouTube
  var ytMatch=url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  if(!ytMatch) ytMatch=url.match(/[?&]v=([A-Za-z0-9_-]{11})/);
  if(ytMatch){
    // autoplay=1         — inicia sozinho
    // mute=1             — obrigatorio para autoplay funcionar no browser
    // controls=0         — esconde barra de controles (play/pause/volume)
    // disablekb=1        — desativa controles por teclado
    // loop=1             — repete o video
    // playlist=ID        — necessario para o loop funcionar no YouTube
    // rel=0              — nao mostra videos relacionados ao final
    // modestbranding=1   — remove logo do YouTube
    // iv_load_policy=3   — oculta anotacoes
    // fs=0               — desativa botao de tela cheia
    // playsinline=1      — toca inline no iOS (sem abrir player nativo)
    var vid=ytMatch[1];
    var params='autoplay=1&mute=1&controls=0&disablekb=1&loop=1&playlist='+vid+'&rel=0&modestbranding=1&iv_load_policy=3&fs=0&playsinline=1';
    return '<div class="promo-media__video" style="pointer-events:none">'+
      '<iframe src="https://www.youtube.com/embed/'+vid+'?'+params+'"'+
      ' allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"'+
      ' loading="lazy" tabindex="-1" aria-hidden="true"></iframe>'+
      '</div>';
  }

  // Vimeo
  var vmMatch=url.match(/vimeo\.com\/(?:video\/)?([0-9]+)/);
  if(vmMatch){
    // autoplay=1   — inicia sozinho
    // muted=1      — obrigatorio para autoplay
    // controls=0   — esconde controles
    // loop=1       — repete
    // title=0      — sem titulo
    // byline=0     — sem autor
    // portrait=0   — sem avatar
    var params='autoplay=1&muted=1&controls=0&loop=1&title=0&byline=0&portrait=0&background=1';
    return '<div class="promo-media__video" style="pointer-events:none">'+
      '<iframe src="https://player.vimeo.com/video/'+vmMatch[1]+'?'+params+'"'+
      ' allow="autoplay; fullscreen; picture-in-picture"'+
      ' loading="lazy" tabindex="-1" aria-hidden="true"></iframe>'+
      '</div>';
  }

  return'';
}

/* =========================================================
   BUILD HTML DO POPUP
   ========================================================= */
function buildPopup(cfg){
  var bg     = cfg.cor_fundo   || '#ffffff';
  var accent = cfg.cor_acento  || '#111111';
  var color  = cfg.cor_texto   || '#111111';
  var color2 = cfg.cor_texto_secundario || '#666666';
  var layout = cfg.layout || 'central';

  var mediaHtml = '';
  // Detecta video pela URL independente do tipo_conteudo
  // (garante funcionar mesmo se o editor salvar tipo errado)
  var videoEmbed = cfg.video_url ? buildVideoEmbed(cfg.video_url) : '';
  if(videoEmbed && (cfg.conteudo === 'video' || !cfg.imagem)){
    mediaHtml = '<div class="promo-media">'+videoEmbed+'</div>';
  } else if(cfg.imagem && cfg.conteudo !== 'video'){
    mediaHtml = '<div class="promo-media"><img class="promo-media__img" src="'+cfg.imagem+'" alt="" loading="lazy"></div>';
  } else if(videoEmbed){
    // fallback: tem URL de video mas tipo_conteudo nao e video — mostra mesmo assim
    mediaHtml = '<div class="promo-media">'+videoEmbed+'</div>';
  }

  // Badge
  var badgeHtml = cfg.badge
    ? '<div class="promo-badge">'+escHtml(cfg.badge)+'</div>'
    : '';

  // Título / subtítulo
  var tituloHtml    = cfg.titulo    ? '<h2 class="promo-titulo">'+escHtml(cfg.titulo)+'</h2>' : '';
  var subtituloHtml = cfg.subtitulo ? '<p class="promo-subtitulo">'+escHtml(cfg.subtitulo)+'</p>' : '';
  var corpoHtml     = cfg.corpo     ? '<p class="promo-corpo">'+escHtml(cfg.corpo)+'</p>' : '';

  // Cupom
  var cupomHtml = '';
  if(cfg.cupom_ativo && cfg.cupom_codigo){
    cupomHtml =
      '<div class="promo-cupom">'+
      (cfg.cupom_label?'<div class="promo-cupom__label">'+escHtml(cfg.cupom_label)+'</div>':'')+
      '<div class="promo-cupom__box">'+
      '<span class="promo-cupom__codigo" id="promo-cupom-codigo">'+escHtml(cfg.cupom_codigo)+'</span>'+
      '<button class="promo-cupom__btn" id="promo-cupom-btn">'+
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>'+
      '<span id="promo-cupom-btn-txt">'+escHtml(cfg.cupom_btn_texto||'Copiar')+'</span>'+
      '</button>'+
      '</div>'+
      '<div class="promo-cupom__toast" id="promo-cupom-toast">✓ Cupom copiado!</div>'+
      '</div>';
  }

  // Botão de ação
  var btnHtml = '';
  if(cfg.btn_ativo && cfg.btn_texto){
    var estilo = cfg.btn_estilo || 'solido';
    var target = cfg.btn_novo_tab ? ' target="_blank" rel="noopener"' : '';
    var link   = cfg.btn_link || '#';
    btnHtml =
      '<div class="promo-actions">'+
      '<a href="'+link+'"'+target+' class="promo-btn promo-btn--'+estilo+'" id="promo-btn-acao">'+
      escHtml(cfg.btn_texto)+
      (estilo!=='link'?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>':'')+
      '</a>'+
      '</div>';
  }

  // Monta body
  var bodyHtml =
    '<div class="promo-body">'+
    badgeHtml+tituloHtml+subtituloHtml+corpoHtml+cupomHtml+
    '</div>';

  // Classe de layout
  var layoutClass = 'promo-popup--'+layout;
  var imgPosClass = (layout==='banner'&&cfg.imagem_posicao==='direita')?'promo-img--direita':'';
  var overlayClass = (layout==='bottom')?'promo-overlay--bottom':'';

  // CSS vars inline
  var styleVars = 'style="--promo-bg:'+bg+';--promo-accent:'+accent+';--promo-color:'+color+';--promo-color2:'+color2+'"';

  // Estrutura interna varia por layout
  var innerHtml;
  if(layout==='bottom'){
    innerHtml = '<div class="promo-inner">'+mediaHtml+bodyHtml+btnHtml+'</div>';
  } else if(layout==='card'){
    innerHtml = mediaHtml+bodyHtml+btnHtml;
  } else if(layout==='banner'){
    // media lateral
    innerHtml = mediaHtml+'<div class="promo-banner-content">'+bodyHtml+btnHtml+'</div>';
  } else {
    // central
    innerHtml = mediaHtml+bodyHtml+btnHtml;
  }

  var html =
    '<div class="promo-overlay promo-hidden '+overlayClass+'" id="promo-overlay" role="dialog" aria-modal="true">'+
    '<div class="promo-popup '+layoutClass+' '+imgPosClass+'" '+styleVars+'>'+
    '<button class="promo-close" id="promo-close" aria-label="Fechar">'+
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">'+
    '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'+
    '</button>'+
    innerHtml+
    '</div></div>';

  return html;
}

function escHtml(str){
  return String(str)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    .replace(/"/g,'&quot;');
}

/* =========================================================
   ESTADO
   ========================================================= */
var S = {
  config: null,
  overlay: null,
  isOpen: false,
  cupomTimer: null
};

/* =========================================================
   ABRIR / FECHAR
   ========================================================= */
function abrir(){
  if(S.isOpen || !S.overlay) return;
  S.isOpen = true;
  document.body.classList.add('promo-body-lock');
  S.overlay.classList.remove('promo-hidden');
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){
      S.overlay.classList.add('promo-visible');
    });
  });
  marcarExibido(S.config);
}

function fechar(){
  if(!S.overlay) return;
  S.overlay.classList.remove('promo-visible');
  document.body.classList.remove('promo-body-lock');
  setTimeout(function(){
    S.overlay.classList.add('promo-hidden');
    S.isOpen = false;
  }, 380);
}

/* =========================================================
   COPIAR CUPOM
   ========================================================= */
function copiarCupom(){
  var cfg = S.config;
  if(!cfg.cupom_codigo) return;

  var codigo = cfg.cupom_codigo;
  var btn    = document.getElementById('promo-cupom-btn');
  var btnTxt = document.getElementById('promo-cupom-btn-txt');
  var toast  = document.getElementById('promo-cupom-toast');

  // Tenta clipboard API primeiro
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(codigo).then(function(){
      mostrarCopiado(btn, btnTxt, toast, cfg);
    }).catch(function(){
      copiarFallback(codigo, btn, btnTxt, toast, cfg);
    });
  } else {
    copiarFallback(codigo, btn, btnTxt, toast, cfg);
  }
}

function copiarFallback(codigo, btn, btnTxt, toast, cfg){
  try{
    var el = document.createElement('textarea');
    el.value = codigo;
    el.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    mostrarCopiado(btn, btnTxt, toast, cfg);
  }catch(e){}
}

function mostrarCopiado(btn, btnTxt, toast, cfg){
  if(btn) btn.classList.add('promo-copiado');
  if(btnTxt) btnTxt.textContent = cfg.cupom_btn_copiado || 'Copiado!';
  if(toast) toast.classList.add('promo-show');

  clearTimeout(S.cupomTimer);
  S.cupomTimer = setTimeout(function(){
    if(btn) btn.classList.remove('promo-copiado');
    if(btnTxt) btnTxt.textContent = cfg.cupom_btn_texto || 'Copiar código';
    if(toast) toast.classList.remove('promo-show');
  }, 3000);
}

/* =========================================================
   GATILHOS DE EXIBIÇÃO
   ========================================================= */
function ativarGatilho(cfg){
  var modo = cfg.modo;

  if(modo === 'manual') return; // só via link externo

  if(modo === 'delay'){
    setTimeout(function(){
      if(!S.isOpen) abrir();
    }, (cfg.delay||3) * 1000);
  }

  else if(modo === 'exit'){
    var disparado = false;
    document.addEventListener('mouseleave', function(e){
      if(disparado || S.isOpen) return;
      if(e.clientY <= 20){
        disparado = true;
        abrir();
      }
    });
    // Mobile: botão voltar / visibilidade
    document.addEventListener('visibilitychange', function(){
      if(!disparado && !S.isOpen && document.hidden){
        disparado = true;
        // Pequeno delay para mobile
        setTimeout(abrir, 200);
      }
    });
  }

  else if(modo === 'scroll'){
    var scrollDisp = false;
    function onScroll(){
      if(scrollDisp || S.isOpen) return;
      var pct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if(pct >= 0.5){
        scrollDisp = true;
        window.removeEventListener('scroll', onScroll, {passive:true});
        abrir();
      }
    }
    window.addEventListener('scroll', onScroll, {passive:true});
  }
}

/* =========================================================
   BIND EVENTOS
   ========================================================= */
function bindEventos(cfg){
  // Fechar
  document.getElementById('promo-close').addEventListener('click', fechar);

  // Fechar ao clicar fora
  if(cfg.fechar_ao_clicar_fora !== false){
    S.overlay.addEventListener('click', function(e){
      if(e.target === S.overlay) fechar();
    });
  }

  // ESC
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && S.isOpen) fechar();
  });

  // Cupom
  var btnCupom = document.getElementById('promo-cupom-btn');
  if(btnCupom) btnCupom.addEventListener('click', copiarCupom);

  // Botão de ação — fecha popup ao clicar
  var btnAcao = document.getElementById('promo-btn-acao');
  if(btnAcao){
    btnAcao.addEventListener('click', function(){
      setTimeout(fechar, 200);
    });
  }

  // Links externos com data-promo-abrir="popup-promocional" abrem o popup manualmente
  document.querySelectorAll('[data-promo-abrir="popup-promocional"]').forEach(function(el){
    el.addEventListener('click', function(e){
      e.preventDefault();
      abrir();
    });
  });
}

/* =========================================================
   BOOT
   ========================================================= */
function boot(){
  var el = document.getElementById('promo-popup-config');
  if(!el) return;

  var cfg;
  try{ cfg = JSON.parse(el.textContent); }
  catch(e){ console.error('[PROMO] Erro config:', e); return; }

  if(!cfg || !cfg.ativo) return;

  S.config = cfg;

  // Verificar frequência
  if(!deveExibir(cfg)){
    return;
  }

  // Insere HTML
  document.querySelectorAll('#promo-overlay').forEach(function(e){e.remove();});
  document.body.insertAdjacentHTML('beforeend', buildPopup(cfg));
  S.overlay = document.getElementById('promo-overlay');

  // Bind
  bindEventos(cfg);

  // Gatilho
  ativarGatilho(cfg);
}

/* =========================================================
   EXPÕE API
   ========================================================= */
window.PromoPopup = {
  abrir:  abrir,
  fechar: fechar,
  config: function(){ return S.config; }
};

/* =========================================================
   INIT
   ========================================================= */
function tryBoot(n){
  n = n || 0;
  if(!document.getElementById('promo-popup-config') && n < 30){
    setTimeout(function(){ tryBoot(n+1); }, 100);
    return;
  }
  boot();
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', function(){ tryBoot(0); });
} else {
  tryBoot(0);
}

})();
